import { useEffect, useState } from 'react'

import { ApiAddressSuggestion } from '@/types/address-suggestions'
import { isAddressInDeliveryArea } from '@/lib/freight'

import { useDebounce } from './use-debounce'
import useSWR from 'swr'
import { getAddressSuggestions } from '@/lib/address-suggestions'

export const useAddressSuggestions = () => {
  const [value, setValue] = useState('')
  const [suggestions, setSuggestions] = useState<ApiAddressSuggestion[]>([])
  // Debounce query so we don't call the API on every keystroke
  const query = useDebounce<string>(value, 300)
  const hasQuery = !!query

  const {
    data,
    isLoading,
    error: hasError,
  } = useSWR(hasQuery ? `address-suggestions-${query}` : null, () => getAddressSuggestions(query))

  useEffect(() => {
    if (!query || !data || hasError) return

    const allSuggestions = data.adresser

    if (!allSuggestions) return

    // Sort list by distance from the user
    const sortedSuggestions = allSuggestions.sort(
      (a, b) =>
        Number(isAddressInDeliveryArea(b.kommunenummer, b.postnummer)) -
        Number(isAddressInDeliveryArea(a.kommunenummer, a.postnummer)),
    )

    setSuggestions(sortedSuggestions)
  }, [data, isLoading])

  return {
    value,
    setValue,
    suggestions,
    setSuggestions,
    isLoading,
  }
}
